<template>
  <div class="risk-dialog">
    <el-dialog
      class="hidden-detail-dlialog"
      :visible.sync="showDialog"
      :modal-append-to-body="false"
      :append-to-body="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="close"
    >
      <div class="content">
        <div class="hidden-close" @click="close">
          关闭
        </div>
        <div class="content-title">
          <!-- <img
            v-if="searchParams.riskLevel !== ''"
            :src="require('@/assets/img/riskIcon/risk-' + searchParams.riskLevel + '.png')"
            alt=""
          /> -->
          <span style="color:#fff">
            {{ riskLevelList[searchParams.riskLevel].levelName }}点
          </span>
        </div>
        <div class="select-box">
          <el-select
            v-model="schoolId"
            @change="schoolChange"
            clearable
            filterable
            size="small"
            placeholder="请选择学院"
            :popper-append-to-body="false"
          >
            <!-- <el-option label="全部" value=""></el-option> -->
            <el-option
              v-for="item in schoolList"
              :key="item.schoolId"
              :label="item.schoolName"
              :value="item.schoolId"
            >
            </el-option>
          </el-select>
        </div>
        <div class="table-wrapper">
          <el-table
            :row-style="getRowClass"
            :cell-style="tableCellStyle"
            :header-row-style="getRowClass"
            :header-cell-style="getRowClass"
            :data="tableData"
            height="580px"
            border
            v-loading="tableLoading"
          >
            <el-table-column label="风险点" align="center">
              <el-table-column
                label="学校名称"
                width="80px"
                show-overflow-tooltip
                align="center"
                prop="schoolName"
              ></el-table-column>
              <el-table-column
                label="编号"
                width="60px"
                show-overflow-tooltip
                align="center"
                prop="id"
              ></el-table-column>
              <el-table-column
                label="类型"
                width="80px"
                show-overflow-tooltip
                align="center"
                prop="riskName"
              ></el-table-column>
              <el-table-column
                label="名称"
                width="80px"
                show-overflow-tooltip
                align="center"
                prop="inspectTarget"
              ></el-table-column>
            </el-table-column>
            <el-table-column
              label="危险源或潜在事件"
              show-overflow-tooltip
              align="center"
              prop="potentialRisk"
            ></el-table-column>
            <el-table-column
              label="可能发生的事故类型及后果"
              show-overflow-tooltip
              align="center"
              prop="faultType"
            ></el-table-column>
            <el-table-column label="管控措施" width="120px" align="center">
              <el-table-column
                label="技术措施"
                width="100px"
                show-overflow-tooltip
                align="center"
                prop="technology"
              ></el-table-column>
              <el-table-column
                label="管理措施"
                width="100px"
                show-overflow-tooltip
                align="center"
                prop="measures"
              ></el-table-column>
              <el-table-column
                label="培训教育措施"
                width="100px"
                show-overflow-tooltip
                align="center"
                prop="education"
              ></el-table-column>
              <el-table-column
                label="个人防护措施"
                width="100px"
                show-overflow-tooltip
                align="center"
                prop="protection"
              ></el-table-column>
              <el-table-column
                label="应急处置措施"
                width="100px"
                show-overflow-tooltip
                align="center"
                prop="disposal"
              ></el-table-column>
            </el-table-column>
            <el-table-column
              label="管理层级"
              width="80px"
              show-overflow-tooltip
              align="center"
              prop="manageLevel"
            >
              <template slot-scope="scope">
                {{ $store.state.select.controlLevel[scope.row.manageLevel].name }}
              </template>
            </el-table-column>
            <el-table-column
              label="负责人"
              width="80px"
              show-overflow-tooltip
              align="center"
              prop="manager"
            ></el-table-column>
          </el-table>
          <el-pagination
            class="pagination"
            :page-size="params.pageSize"
            :pager-count="5"
            :current-page="params.pageNum"
            layout="total, prev, pager, next"
            :total="total"
            @current-change="currentChange"
          >
          </el-pagination>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "riskDialog",
  props: {
    show: {
      type: Boolean,
    },
    searchParams: {
      type: Object,
    },
  },
  data() {
    return {
      eduInfo: JSON.parse(sessionStorage.getItem("eduInfo")),
      params: {
        eduId: "", //教育局id
        regionCode: "", //区域编码
        eduBuresuType: "", //教育局类型
        riskLevel: "",
        pageNum: 1,
        pageSize: 20,
      },
      showDialog: false,
      tableData: [],
      tableLoading: false,
      total: 0,
      schoolList: [],
      schoolId: this.searchParams.collegeId,
    };
  },
  created() {},
  mounted() {},
  methods: {
    async getStandingBooks() {
      this.tableLoading = true;
      let req = Object.assign({}, this.params);
      let res = await this.$Http.getStandingBooks(req);
      this.tableLoading = false;
      if (res.code == 200) {
        if (res.data) {
          this.tableData = res.data.list || [];
          this.total = res.data.total || 0;
        } else {
          this.tableData = res.data.list || [];
          this.total = res.data.total || 0;
        }
      } else if (res.code == 101) {
        this.tableData = [];
        this.total = 0;
      } else {
        this.tableData = [];
        this.total = 0;
      }
    },
    // 分页点击
    currentChange(val) {
      this.params.pageNum = val;
      this.getStandingBooks();
    },
    close() {
      this.$emit("close");
    },
    // 修改 table cell边框的背景色
    tableCellStyle() {
      return "border-color: #fff;";
    },
    getRowClass({ row, column, rowIndex, columnIndex }) {
      return "background:#c4f0ff;color:#c4f0ff";
    },
    async getSchoolList() {
      let req = {
        collegeId: this.userInfo.eduId
      };
      let res = await this.$Http.getCollegeList(req);
      if (res.code == 200) {
          this.schoolList = res.data || []
      } else if (res.code == 101) {
        this.schoolList = [];
      } else {
        this.schoolList = [];
      }
    },
    schoolChange(val) {
      this.params.schoolId = parseInt(val);
      this.getStandingBooks();
    },
  },
  watch: {
    show: function(nval) {
      if (nval) {
        this.params = Object.assign({}, this.searchParams);
        this.params.schoolId = this.params.collegeId
        this.schoolId = this.params.collegeId
        this.params.pageNum = 1;
        this.params.pageSize = 20;
        this.total = 0;
        this.getSchoolList();
        this.getStandingBooks();
      }
      this.showDialog = nval;
    },
  },
  computed: {
    riskLevelList() {
      return this.$store.state.select.riskLevel.map((item) => {
        return { color: item.color, levelName: item.levelNameOne };
      });
    },
    userInfo() {
      return JSON.parse(sessionStorage.getItem("userInfo"));
    }
  },
};
</script>
<style scoped lang="scss">
.risk-dialog {
  /deep/ .hidden-detail-dlialog {
    .el-dialog {
      width: 1380px;
      height: 740px;
      // 已修改
      background: url("~@/assets/img/hiddenDangerNow/hidden-detail-dialog-bg.png") center center
        no-repeat;
      background-size: 100% 100%;
      padding: 20px 46px 10px 34px;
      .el-dialog__header {
        display: none;
      }
      .el-dialog__body {
        padding: 0;
      }
    }
  }
}
.select-box {
  // margin-left: 10px;
  position: relative;
  /deep/ .el-select{
    .el-input__inner {
      background-color: transparent;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #c4f0ff;
      line-height: 20px;
    }
    .el-select-dropdown {
      background: rgba(28, 102, 168, 0.8);
      box-shadow: 0px 0px 28px 0px #3f78bc inset;
      position: absolute !important;
      top: 26px !important;
    }
    .el-select-dropdown__item {
      color: #ffffff;
    }
    .el-select-dropdown__item.hover {
      color: #c4f0ff;
      background: rgba(25, 63, 97,0.8);
    }
    .el-select-dropdown__item.selected,
    .el-select-dropdown__item.selected.hover {
      color: #409eff;
      background: rgba(25, 63, 97,0.8);
    }
  }
}
.content {
  width: 100%;
  height: 100%;
  position: relative;
  .hidden-close {
    width: 56px;
    height: 24px;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #d7deff;
    line-height: 25px;
    letter-spacing: 1px;
    position: absolute;
    top: 10;
    right: 0;
    cursor: pointer;
  }
  .content-title {
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 64px;
      height: 64px;
    }
    span {
      margin-left: 16px;
      font-size: 24px;
    }
  }
}
.table-wrapper {
    margin-top: 5px;
  /deep/ .el-table {
    padding: 0px;
    background-color: transparent;
    .el-table__expanded-cell {
      background-color: transparent;
    }
    th,
    tr {
      background-color: transparent !important;
      &:hover td{
        background-color: transparent !important;
      }
    }
    .el-table--enable-row-transition {
      .el-table__body {
        td {
          background-color: transparent;
          color: #c4cdff;
        }
      }
    }
    .cell {
      background-color: transparent;
      color: #c4cdff;
    }
  }
}
.pagination {
  /deep/ &.el-pagination {
  margin: 10px;
  float: right;
  background-color: transparent;
    .el-pagination__total {
      color: rgba(255, 255, 255, 0.8);
    }
    button{
      width: 28px;
      min-width: 28px;
      border-radius: 6px;
      background: transparent;
      border: 1px solid rgba(44,166,252,1);
      box-shadow: inset 0px 1px 16px 0px rgba(65, 77, 161, 0.5);
      &:hover {
        background: rgba(44,166,252,1);
      }
      &:disabled {
        background: transparent;
        cursor: default;
      }
      .el-icon {
        color: #ffffff;
        &.el-icon-arrow-right {
          position: relative;
          left: -4px;
        }
      }
    }
    .el-pager {
      li {
        color: rgba(255, 255, 255, 0.6);
        background: transparent;
        &:hover,
        &.active {
          color: #ffffff;
        }
      }
    }
  }
}
</style>
